import { useState } from "react";
import { MoreHorizontal } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../ui/sheet";

const PRIMARY = 4;

export const MobileTabs = ({ tabs, tab, setTab, pending }) => {
  const [more, setMore] = useState(false);
  const extra = tabs.slice(PRIMARY);
  const inExtra = extra.some((t) => t.id === tab);
  const go = (id) => { setTab(id); setMore(false); window.scrollTo({ top: 0 }); };

  const Item = ({ id, label, icon: Icon, active, onClick, badge }) => (
    <button data-testid={`parent-mtab-${id}`} onClick={onClick} className={`relative flex flex-col items-center gap-1 py-2.5 font-display text-[11px] font-semibold ${active ? "text-[#1B1A2E]" : "text-[#1B1A2E]/50"}`}>
      <span className={`px-4 py-1 rounded-full border-2 ${active ? "bg-[#FFD23F] border-[#1B1A2E]" : "border-transparent"}`}><Icon size={20} /></span>
      {label}
      {badge > 0 && <span className="absolute top-1 right-[18%] bg-[#FF6B4A] text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] px-1 grid place-items-center border-2 border-white">{badge}</span>}
    </button>
  );

  return (
    <>
      <nav data-testid="parent-bottom-nav" className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t-[3px] border-[#1B1A2E] grid grid-cols-5 pb-[env(safe-area-inset-bottom)]">
        {tabs.slice(0, PRIMARY).map((t) => (
          <Item key={t.id} {...t} label={t.short || t.label} active={tab === t.id} onClick={() => go(t.id)} badge={t.id === "approvals" ? pending : 0} />
        ))}
        <Item id="more" label="More" icon={MoreHorizontal} active={inExtra} onClick={() => setMore(true)} />
      </nav>
      <Sheet open={more} onOpenChange={setMore}>
        <SheetContent side="bottom" data-testid="parent-more-sheet" className="rounded-t-3xl border-t-[3px] border-[#1B1A2E] pb-[calc(1.5rem+env(safe-area-inset-bottom))]">
          <SheetHeader><SheetTitle className="font-display text-2xl text-left">More</SheetTitle></SheetHeader>
          <div className="grid gap-2 mt-4">
            {extra.map(({ id, label, icon: Icon }) => (
              <button key={id} data-testid={`parent-more-${id}`} onClick={() => go(id)} className={`flex items-center gap-3 px-4 py-4 rounded-2xl border-[3px] font-display font-medium text-lg ${tab === id ? "bg-[#1B1A2E] text-white border-[#1B1A2E]" : "bg-white border-[#1B1A2E]/15"}`}>
                <Icon size={20} /> {label}
              </button>
            ))}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};
